const getBase64ImageType = (image: string) => {
  return check(image, 'png') ? 'png' : check(image, 'jpeg') ? 'jpeg' : 'jpg';
};

const check = (image: string, type: string): boolean => {
  return image.includes(type);
};

export default getBase64ImageType;
